/**
 * This module handles all validation functionality with redux-form-validations,
 * including any custom validators
 */
import Validators, { addValidator } from 'redux-form-validators'

/**
 * Default overrides - general settigns
 */
Validators.defaultOptions = {
  ...Validators.defaultOptions,
  caseSensitive: false,
}

/**
 * Custom validation messages (to override messages from out-of-the-box validators)
 */
Validators.messages = {
  ...Validators.messages,
  presence: 'Required',
  tooShort: '{count, number} Character Minimum',
  tooLong: '{count, number} Character Maximum',
}

/**
 * Custom validators
 */
export const doesNotIncludeHttp = addValidator({
  defaultMessage: 'Do not include "http://"',
  validator: function (_, value) {
    return /^(?!(http:\/\/|https:\/\/)).*$/g.test(value)
  },
})

export const validUrlWithoutProtocol = addValidator({
  defaultMessage: 'Invalid URL',
  validator: function (options, value) {
    return (
      (options.allowBlank && !value) ||
      /^[-a-zA-Z0-9@:%_+.~#?&/=]{2,256}\.[a-z]{2,4}((\/|\?)[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/gi.test(
        value
      )
    )
  },
})

export const validUrl = addValidator({
  defaultMessage: 'Invalid URL',
  validator: function (options, value) {
    return (
      (options.allowBlank && !value) ||
      /^(http:\/\/|https:\/\/)[-a-zA-Z0-9@:%_+.~#?&/=]{2,256}\.[a-z]{2,4}((\/|\?)[-a-zA-Z0-9@:%_+.~#?&/=]*)?$/gi.test(
        value
      )
    )
  },
})

/**
 * Verify time is in HH:MM AM format, and not something like 16:45 AM
 */
export const validTime = addValidator({
  defaultMessage: 'Invalid time specified',
  validator: function (options, value) {
    return (
      (options.allowBlank && !value) ||
      /^((1[0-2]|0[1-9]):([0-5][0-9]) ([AaPp][Mm]))$/g.test(value)
    )
  },
})

export { Validators }
export * from 'redux-form-validators'
